import { CancellationSummary, TripAdjustmentResponse } from 'guest-data-types-ts-lib/types';
import { ExtendedStaySummary } from 'guest-data-types-ts-lib/types/adjustments';

export interface ReservationGuest {
    type: 'reservation-guests';
    attributes: {
        id: number;
        reservationId: number;
        first_name: string;
        last_name: string;
        email: string;
    };
}

export interface Vehicle {
    type: 'reservation-vehicle';
    attributes: {
        license_state: string;
        license_number: string;
    };
}

export interface tripAvailability {
    type: 'trips-availability';
    id: string;
    attributes: {
        id: string;
        checkin: string;
        checkout: string;
        extended_checkins: Array<{
            date: string;
            bookable: boolean;
        }>;
        extended_checkouts: Array<{
            date: string;
            bookable: boolean;
        }>;
    };
}

export interface VehicleInfox {
    parking_total_cars: number;
    parking_instructions: string;
    garage_parking: number | null;
    four_wheel_drive: null;
    four_wheel_drive_instructions: null;
}

export interface Idv {
    status: IdvStatus;
    url: string;
}

export enum IdvStatus {
    PASSED = 'PASSED',
    FAILED = 'FAILED',
    IN_PROGRESS = 'IN_PROGRESS',
}

export const BedTypes: { [key: string]: string } = {
    king_bed: 'king_bed',
    queen_bed: 'queen_bed',
    double_bed: 'double_bed',
    twin_bed: 'twin_bed',
    child_bed: 'child_bed',
    murphy_bed: 'murphy_bed',
};

export const BathroomTypes: { [key: string]: string } = {
    full_bathroom: 'full_bath',
    half_bathroom: 'half_bath',
};

export interface WetSignatureDetails {
    footer: string;
    header_one: string;
    header_two: string;
}

export enum AdjustmentsAnalyticsEvents {
    ADJUSTMENT_BILLING_DETAILS = 'Trip Portal Billing Details',
    ADJUSTMENT_PAYMENT_COMPLETE = 'Trip Portal Payment Completed',
    ADJUSTMENT_CANCELLATION_COMPLETE = 'Reservation Cancelled',
    ADJUSTMENT_BILLING_ERROR = 'Trip Portal Billing Error',
}

export interface FolioDelta {
    fees: number;
    taxes: number;
    rent: number;
    total: number;
    currency: string;
}

export interface AdjustmentResponse {
    type: string;
    attributes: TripAdjustmentResponse | CancellationSummary | ExtendedStaySummary;
}

export interface Payment {
    amount: {
        currency: string;
        total: number;
    };
    payee: {
        address: {
            city: string;
            postalCode: string;
            state: string;
            street1: string;
            country: string;
        };
    };
    paymentInstrument: {
        nameOnAccount: {
            first: string;
            last: string;
        };
        creditCard: {
            cardNumber: string;
            expirationMonth: string;
            expirationYear: string;
            cvv: string;
        };
    };
}

export interface Review {
    rating: number | null;
    is_eligible: boolean;
    review_base_url: string;
}

export interface Photo {
    image_rank: number;
    url: string;
    id: string;
}

export interface MinifiedReservation {
    id: string;
    confirmation_code?: string;
}
